// 咨询订单
export const PAGE_CONSULTING_ORDER = 'zyjk-page-consulting-order';
// 我的处方
export const PAGE_PRESCRIPTION = 'zyjk-page-prescription';

// #region 已埋
// 专家问诊-点击科室: 需要支持根据科室统计
// 专家问诊-搜索-结果-点击科室筛选
export const CLICK_EXPERT_CONSULTATION_DEPARTMENT = 'zyjk-click-expert-consultation-department';

// 专家问诊-搜索-结果-点击地区筛选
export const CLICK_EXPERT_CONSULTATION_AREA = 'zyjk-click-expert-consultation-area';
// 专家问诊-搜索-结果-点击筛选
export const CLICK_EXPERT_CONSULTATION_FILTER = 'zyjk-click-expert-consultation-filter';
// 专家问诊-搜索-结果-地区筛选-选择地区: 需要支持根据地区统计
export const CLICK_EXPERT_CONSULTATION_AREA_SELECT = 'zyjk-click-expert-consultation-area-select';
// 专家问诊-搜索-结果-地区筛选-选择科室: 需要支持根据科室统计
export const CLICK_EXPERT_CONSULTATION_DEPARTMENT_SELECT = 'zyjk-click-expert-consultation-department-select';
// 专家问诊-搜索-结果-筛选-选择
export const CLICK_EXPERT_CONSULTATION_FILTER_ITEM = 'zyjk-click-expert-consultation-filter-item';
// 专家问诊-搜索-结果-筛选-筛选-点击重置
export const CLICK_EXPERT_CONSULTATION_FILTER_RESET = 'zyjk-click-expert-consultation-filter-reset';
// 专家问诊-搜索-结果-筛选-筛选-点击确定
export const CLICK_EXPERT_CONSULTATION_FILTER_DETERMINE = 'zyjk-click-expert-consultation-filter-determine';

// 按医院找医生-点击选择地区
export const CLICK_EXPERT_CONSULTATION_HOSPITAL_DOCTOR_AREA_SELECT =
  'zyjk-click-expert-consultation-hospital-doctor-area-select';
// 按医院找医生-点击选择类型
export const CLICK_EXPERT_CONSULTATION_HOSPITAL_DOCTOR_TYPE_SELECT =
  'zyjk-click-expert-consultation-hospital-doctor-type-select';
// 按医院找医生-选择医院: 需要支持根据医院统计
export const CLICK_EXPERT_CONSULTATION_HOSPITAL_DOCTOR_SELECT = 'zyjk-click-expert-consultation-hospital-doctor-select';
// 医院主页-点击医院主页
export const CLICK_EXPERT_CONSULTATION_HOSPITAL_HOME = 'zyjk-click-expert-consultation-hospital-home';

// 专家问诊
export const PAGE_EXPERT_CONSULTATION = 'zyjk-page-expert-consultation';
// 专家问诊-搜索
export const PAGE_EXPERT_CONSULTATION_SEARCH = 'zyjk-page-expert-consultation-search';
// 专家问诊-搜索-结果
export const PAGE_EXPERT_CONSULTATION_SEARCH_RESULT = 'zyjk-page-expert-consultation-search-result';
// 专家问诊-按科室找医生-科室医生结果
export const PAGE_EXPERT_CONSULTATION_DEPARTMENT_DOCTOR_RESULTS =
  'zyjk-page-expert-consultation-department-doctor-results';
// 专家问诊-按医院找医生
export const PAGE_EXPERT_CONSULTATION_HOSPITAL = 'zyjk-page-expert-consultation-hospital';
// 专家问诊-医院详情页
export const PAGE_EXPERT_CONSULTATION_HOSPITAL_DETAILS = 'zyjk-page-expert-consultation-hospital-details';
// 专家问诊-医院详情页-医院简介
export const PAGE_EXPERT_CONSULTATION_HOSPITAL_INTRODUCTION = 'zyjk-page-expert-consultation-hospital-introduction';
// 专家问诊-按医院找医生-科室医生结果页
export const PAGE_EXPERT_CONSULTATION_HOSPITAL_DOCTOR_RESULTS = 'zyjk-page-expert-consultation-hospital-doctor-results';
// 医生主页: 需要支持根据医生统计
export const PAGE_DOCTOR_HOME = 'zyjk-page-doctor-home';
// 专家问诊支付页
export const PAGE_EXPERT_CONSULTATION_PAY = 'zyjk-page-expert-consultation-pay';

// 快速问诊支付
export const ZYJK_PAGE_QUICKINQUIRY_PAY = 'zyjk-page-quickinquiry-pay';

// 快速问诊-支付页-立即支付
export const ZYJK_CLICK_QUICKINQUIRY_PAY_PAY = 'zyjk-click-quickinquiry-pay-pay';

// 快速问诊-支付页-返回-取消咨询
export const ZYJK_CLICK_QUICKINQUIRY_PAY_BACK_CANCEL = 'zyjk-click-quickinquiry-pay-back-cancel';

// 快速问诊-支付页-返回-继续支付
export const ZYJK_CLICK_QUICKINQUIRY_PAY_BACK_PAY = 'zyjk-click-quickinquiry-pay-back-pay';

// 快速问诊-支付页-返回
export const ZYJK_CLICK_QUICKINQUIRY_PAY_BACK = 'zyjk-click-quickinquiry-pay-back';

// 专家问诊-点击按医院找医生
export const CLICK_EXPERT_CONSULTATION_HOSPITAL_DOCTOR = 'zyjk-click-expert-consultation-hospital-doctor';

// 专家问诊-点击搜索框
export const CLICK_EXPERT_CONSULTATION_SEACH = 'zyjk-click-expert-consultation-seach';
// 专家问诊-点击banner1
export const CLICK_EXPERT_CONSULTATION_BANNER1 = 'zyjk-click-expert-consultation-banner1';
// 专家问诊-点击banner2
export const CLICK_EXPERT_CONSULTATION_BANNER2 = 'zyjk-click-expert-consultation-banner2';
// 专家问诊-点击全部科室
export const CLICK_EXPERT_CONSULTATION_ALL_DEPARTMENT = 'zyjk-click-expert-consultation-all-department';
// 专家问诊-搜索-点击取消
export const CLICK_EXPERT_CONSULTATION_SEARCH_CANCEL = 'zyjk-click-expert-consultation-search-cancel';
// 专家问诊-搜索-点击清除历史数据
export const CLICK_EXPERT_CONSULTATION_SEARCH_CLEAR = 'zyjk-click-expert-consultation-search-clear';
// 专家问诊-搜索-点击历史搜索
export const CLICK_EXPERT_CONSULTATION_SEARCH_HISTORY = 'zyjk-click-expert-consultation-search-history';
// 专家问诊-点击名医推荐: 需要支持根据医生统计
export const CLICK_FAMOUS_DOCTORS = 'zyjk-click-famous-doctors';

// 医生主页-点击关注
export const CLICK_EXPERT_DOCTOR_HOME_ATTENTION = 'zyjk-click-expert-doctor-home-attention';
// 医生主页-点击取消关注
export const CLICK_EXPERT_DOCTOR_HOME_UNSUBSCRIBE = 'zyjk-click-expert-doctor-home-unsubscribe';
// 医生主页-点击价格
export const CLICK_EXPERT_DOCTOR_HOME_INQUIRY1 = 'zyjk-click-expert-doctor-home-inquiry1';
// 医生主页-点击立即问诊
export const CLICK_EXPERT_DOCTOR_HOME_INQUIRY2 = 'zyjk-click-expert-doctor-home-inquiry2';
// 专家问诊-支付-点击返回
export const CLICK_EXPERT_DOCTOR_PAY_RETURN = 'zyjk-click-expert-doctor-pay-return';
// 专家问诊-支付-点击立即支付
export const CLICK_EXPERT_DOCTOR_PAY = 'zyjk-click-expert-doctor-pay';
// 云币不足-点击购买
export const CLICK_EXPERT_DOCTOR_PAY_BUY = 'zyjk-click-expert-doctor-pay-buy';
// 云币不足-点击做任务
export const CLICK_EXPERT_DOCTOR_PAY_BUY_TASK = 'zyjk-click-expert-doctor-pay-buy-task';
// #endregion

// #region 做不了
// 医生主页-点击返回
export const CLICK_EXPERT_DOCTOR_HOME_RETURN = 'zyjk-click-expert-doctor-home-return';
// 医生主页-点击分享
export const CLICK_EXPERT_DOCTOR_HOME_SHARE = 'zyjk-click-expert-doctor-home-share';
// #endregion
